var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabBlueSapphire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.96 14.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n        .cls-1 {\n        fill: #040425;\n        }\n\n        .cls-2 {\n        fill: #03031d;\n        }\n\n        .cls-3 {\n        fill: #7d7d7d;\n        }\n\n        .cls-4 {\n        fill: #9f9f9f;\n        }\n\n        .cls-5 {\n        fill: #b0b0b0;\n        }\n\n        .cls-6 {\n        fill: #1212a3;\n        }\n\n        .cls-7 {\n        fill: #1313ae;\n        }\n\n        .cls-8 {\n        fill: #1717ce;\n        }\n\n        .cls-9 {\n        fill: #0b0b65;\n        }\n\n        .cls-10 {\n        fill: #0b0b60;\n        }\n\n        .cls-11 {\n        fill: #0b0b62;\n        }\n\n        .cls-12 {\n        fill: #09094e;\n        }\n\n        .cls-13 {\n        fill: #080848;\n        }\n\n        .cls-14 {\n        fill: #11119b;\n        }\n\n        .cls-15 {\n        fill: #111197;\n        }\n\n        .cls-16 {\n        fill: #10108e;\n        }\n\n        .cls-17 {\n        fill: #101091;\n        }\n\n        .cls-18 {\n        fill: #0a0a59;\n        }\n\n        .cls-19 {\n        fill: #0a0a5b;\n        }\n\n        .cls-20 {\n        fill: #0a0a5e;\n        }\n\n        .cls-21 {\n        fill: #0e0e80;\n        }\n\n        .cls-22 {\n        fill: #0e0e7c;\n        }\n\n        .cls-23 {\n        fill: #717171;\n        }\n\n        .cls-24 {\n        fill: #6e6e6e;\n        }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "colors"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 7.47,
    cy: 7.49,
    r: 7.49
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Facets"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m4.46,14.35c.32.14.65.27,1,.37-.34-.1-.67-.23-.99-.37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m.61,10.44h-.01c.75,1.73,2.11,3.13,3.84,3.89h0c-1.72-.77-3.08-2.16-3.83-3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m-.02,7.49C-.02,6.45.2,5.45.59,4.54h0s0,0,0,0c.77-1.78,2.2-3.2,3.99-3.95h0s0,0,0,0C5.47.21,6.45,0,7.47,0c.67,0,1.32.09,1.94.25C8.79.09,8.14,0,7.46,0,3.33,0-.03,3.36-.03,7.49c0,1.03.23,2,.61,2.9h0C.21,9.49-.02,8.52-.02,7.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m9.76,14.62c-.1.03-.21.06-.32.08.11-.03.21-.05.32-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m13.92,3.71c.06.1.12.21.18.31-.06-.11-.12-.21-.18-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m11.5,1.19c.06.04.12.07.17.11-.06-.04-.11-.07-.17-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m12.44,1.9c.08.07.16.14.24.22-.08-.08-.16-.15-.24-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m13.31,2.81c.07.09.13.18.2.26-.07-.09-.13-.18-.2-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m8.8,14.85c-.12.02-.24.04-.37.06.12-.02.25-.04.37-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m13.97,11.2c-.08.14-.16.27-.25.4.09-.13.17-.26.25-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m13.42,12.02c-.13.17-.27.34-.41.5.15-.16.28-.33.41-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m10.91,14.13c-.11.06-.23.12-.35.17.12-.05.23-.11.35-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m12.66,12.88c-.11.1-.21.2-.32.3.11-.1.22-.19.32-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m11.77,13.62c-.12.08-.24.16-.37.24.12-.08.25-.15.37-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m10.5.65c.06.03.13.06.19.09-.06-.03-.13-.06-.19-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m5.46,14.71c.64.18,1.31.27,2.01.27.04,0,.09,0,.13,0-.05,0-.09,0-.14,0-.69,0-1.36-.09-2-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m14.94,7.25c0,.08.01.16.01.25,0,1.05-.21,2.04-.6,2.94v.02c.39-.91.61-1.91.61-2.96,0-.08-.02-.16-.02-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m14.19,10.77c.05-.11.12-.21.16-.32h0s-.01,0-.01,0c-.05.11-.1.21-.15.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m14.46,4.83c.05.12.09.24.13.37-.04-.12-.08-.25-.13-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m14.82,6.08c.02.13.04.26.06.39-.02-.13-.03-.26-.06-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m3.43,5.81l-.49-2.79,1.64-2.43c-1.79.75-3.22,2.17-3.99,3.95l2.34-1.52.5,2.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m4.58.58l2.89.48,2.95-.45c-.33-.14-.66-.26-1.01-.35C8.79.09,8.14,0,7.47,0,6.45,0,5.47.21,4.58.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m13.85,7.65l.5,2.79c.39-.9.6-1.9.6-2.94,0-.08,0-.16-.01-.25,0-.26-.03-.52-.07-.77-.02-.13-.03-.26-.06-.39-.06-.3-.14-.59-.23-.88-.04-.12-.08-.25-.13-.37-.02-.06-.04-.12-.06-.18l-.55,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m7.33,13.93l-2.87.41c.32.14.65.27.99.37.64.18,1.31.27,2,.27.05,0,.09,0,.14,0,.28,0,.56-.03.84-.06.12-.02.25-.04.37-.06.22-.04.43-.09.64-.15.11-.03.21-.05.32-.08.24-.08.48-.17.71-.27l-3.14-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m12.05,11.91l-1.56,2.44s.05-.03.07-.04c.12-.05.23-.11.35-.17.17-.09.33-.18.49-.28.12-.08.25-.15.37-.24.2-.14.39-.29.57-.44.11-.1.22-.2.32-.3.12-.12.23-.24.35-.36.14-.16.28-.33.41-.5.1-.14.21-.28.3-.42.09-.13.17-.26.25-.4.08-.14.15-.28.22-.43.05-.1.11-.2.15-.31l-2.29,1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m12.09,3.03l2.29,1.6c-.09-.21-.18-.41-.28-.6-.06-.11-.12-.21-.18-.31-.13-.22-.27-.43-.42-.63-.06-.09-.13-.18-.2-.26-.2-.25-.41-.47-.64-.69-.08-.07-.16-.15-.24-.22-.24-.22-.5-.42-.77-.61-.06-.04-.12-.07-.17-.11-.26-.17-.53-.31-.81-.45-.06-.03-.13-.06-.19-.09-.03-.01-.05-.03-.08-.04l1.67,2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m4.44,14.33l-1.49-2.3-2.34-1.59c.75,1.73,2.11,3.13,3.83,3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m-.02,7.49c0,1.03.23,1.99.6,2.88l.53-2.79-.52-3.04C.2,5.45-.02,6.45-.02,7.49Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "11.55 5.81 9.28 3.36 5.84 3.37 3.43 5.81 3.4 9.22 5.77 11.59 9.14 11.63 11.51 9.17 11.55 5.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "9.28 3.36 7.47 1.06 5.84 3.37 9.28 3.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2.95 12.03 5.77 11.59 3.4 9.22 2.95 12.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "7.33 13.93 9.14 11.63 5.77 11.59 7.33 13.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "13.85 7.65 11.55 5.81 11.51 9.17 13.85 7.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "9.14 11.63 12.05 11.91 11.51 9.17 9.14 11.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "1.11 7.59 3.4 9.22 3.43 5.81 1.11 7.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "3.43 5.81 5.84 3.37 2.94 3.02 3.43 5.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "12.09 3.03 9.28 3.36 11.55 5.81 12.09 3.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "2.93 3.02 .59 4.54 .59 4.54 .59 4.54 1.11 7.59 3.43 5.81 2.93 3.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "5.84 3.37 7.47 1.06 4.58 .58 4.58 .58 4.58 .59 2.94 3.02 5.84 3.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m14.4,4.64h-.01s0,0,0,.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m12.09,3.03l-.54,2.78,2.3,1.84.55-3s0-.01,0-.02l-2.29-1.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "10.42 .61 10.42 .61 10.42 .61 10.42 .61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "7.47 1.06 9.28 3.36 12.09 3.03 10.42 .61 10.42 .61 7.47 1.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "2.95 12.03 3.4 9.22 1.11 7.59 .58 10.38 .58 10.39 .57 10.42 .6 10.44 .61 10.44 2.95 12.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "7.33 13.93 5.77 11.59 2.95 12.03 4.44 14.33 4.44 14.34 4.45 14.35 4.46 14.35 4.47 14.35 7.33 13.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m14.34,10.46h.01s0-.02,0-.02c0,0,0,.02-.01.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m11.51,9.17l.54,2.73,2.29-1.45s0-.02.01-.02l-.5-2.79-2.34,1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m10.49,14.35h0s-.01,0-.02,0h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m12.05,11.91l-2.91-.28-1.8,2.31,3.14.42s.01,0,.02,0l1.56-2.44Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabBlueSapphire);
export default __webpack_public_path__ + "static/media/LabBlueSapphire.e57b69187999647ca1c36be8ab261e0b.svg";
export { ForwardRef as ReactComponent };